import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccountBlockedComponent } from './components/account-blocked/account-blocked.component';
import { SharedModule } from '../shared/shared.module';
import { I2gNgUiModule } from 'i2g-ng-ui';
import { SupportModule } from '../support/support.module';
import { DialogModule } from '../dialog/dialog.module';
import { AccountBlockedGuard } from './account-blocked.guard';
import { VerifyEmailNotificationComponent } from './components/verify-email-notification/verify-email-notification.component';
import { VerifyAccountEffects } from './verify-account.effects';
import { I2gNgUtilsModule } from 'i2g-ng-utils';

export const verifyAccountEffects = [VerifyAccountEffects];

@NgModule({
  declarations: [AccountBlockedComponent, VerifyEmailNotificationComponent],
  providers: [AccountBlockedGuard],
  imports: [
    CommonModule,
    SharedModule,
    I2gNgUiModule,
    I2gNgUtilsModule,
    SupportModule,
    DialogModule,
  ],
  exports: [AccountBlockedComponent, VerifyEmailNotificationComponent],
})
export class VerifyAccountModule {}
